import React from 'react';
import { VideoCameraIcon } from '@heroicons/react/24/outline';
import './Camera.css';

const ACTIVE = ['requesting_camera', 'preview', 'creating', 'connecting', 'live'];

// Permanent signed-in topbar control. It only opens the camera panel; it never
// captures. aria-checked reflects whether this account currently holds capture.
export default function CameraSwitch({ camera }) {
  const status = camera.state.status;
  const on = ACTIVE.includes(status);
  const title = status === 'live' ? 'Camera (Live)' : on ? 'Camera (On)'
    : status === 'stop_unconfirmed' ? 'Camera (Stop unconfirmed)' : 'Camera (Off)';
  return (
    <button type="button" role="switch" aria-checked={on} aria-label="Camera" title={title}
      className={`camera-top-btn camera-${status}`} onClick={camera.openPanel}>
      <VideoCameraIcon style={{ width: 22, height: 22 }} />
      <span className={`camera-status-indicator ${status === 'live' ? 'live' : on ? 'on' : status === 'stop_unconfirmed' ? 'warn' : 'off'}`} />
    </button>
  );
}
